<h2 data-test-id="change-password-page-heading" #pageHeading aria-describedby="pageDescription" tabindex="-1">{{ CONSTANTS.title }}</h2>
@if (didSaveSucceed) {
  <success-message data-test-id="change-password-success-message" [message]="CONSTANTS.successMessage"></success-message>
}
@if (didSaveFail) {
  <error-message data-test-id="change-password-error-message"></error-message>
}
<p data-test-id="change-password-page-description" id="pageDescription">{{ CONSTANTS.instructions }}</p>

<form data-test-id="change-password-form" [formGroup]="credentialsForm" #ngForm="ngForm" (submit)="onSubmit()">
  @if (isFormInvalid) {
    <strong
      data-test-id="change-password-form-errors-message"
      class="text-danger mb-3"
      [class.is-invalid]="isFormInvalid"
      aria-live="polite"
      id="reviewErrors"
      tabindex="-1"
      >
      <i class="allycon-error-fill"></i>
      {{ displayFormErrorsMessage }} {{ CONSTANTS.reviewErrors }}
    </strong>
  }

  <div class="form-group">
    <label data-test-id="change-password-old-password-label" for="passwordOld" id="passwordOld-label">{{ CONSTANTS.oldPassword }}</label>

    <div class="control-wrapper open-input-field">
      <input
        data-test-id="change-password-old-password-input"
        type="password"
        (keypress)="restrictPwd($event)"
        class="form-control col-sm-12 col-md-6 col-lg-6 col-xl-4"
        id="passwordOld"
        formControlName="passwordOld"
        [class.is-invalid]="isPasswordOldInvalid"
        aria-required="true"
        aria-labelledby="passwordOld-label passwordOld-error"
        />

      @if (isPasswordOldEmpty) {
        <span data-test-id="change-password-old-password-empty-error" class="invalid-feedback" aria-live="polite" id="passwordOld-empty-error">{{
          CONSTANTS.passwordOldEmptyError
        }}</span>
      }
      @if (isPasswordOldWrongPassword) {
        <span
          data-test-id="change-password-old-password-wrong-error"
          class="invalid-feedback"
          aria-live="polite"
          id="passwordOld-wrong-password"
          >{{ CONSTANTS.errorWrongPassword }}</span
          >
        }
      </div>
    </div>

    <div class="form-group">
      <label data-test-id="change-password-new-password-label" for="passwordNew" id="passwordNew-label">{{ CONSTANTS.newPassword }}</label>
      <div class="d-md-flex">
        <div class="control-wrapper col-md-6 col-lg-6 col-xl-4 px-0">
          <input
            data-test-id="change-password-new-password-input"
            type="password"
            (keypress)="restrictPwd($event)"
            class="form-control col-sm-12"
            id="passwordNew"
            formControlName="passwordNew"
            [class.is-invalid]="isPasswordNewInvalid"
            aria-required="true"
            aria-labelledby="passwordNew-label passwordNew-desc passwordNew-error-empty passwordNew-error-lowercase passwordNew-error-number passwordNew-error-length passwordNew-error-uppercase passwordNew-error-max passwordNew-error-username"
            />

          @if (isPasswordNewPreviousPassword) {
            <span
              data-test-id="change-password-new-password-previous-error"
              class="invalid-feedback"
              aria-live="polite"
              id="passwordNew-previous-password"
              >{{ CONSTANTS.errorPreviousPassword }}</span
              >
            }
            @if (isPasswordNewEmpty) {
              <span data-test-id="change-password-new-password-empty-error" class="invalid-feedback" aria-live="polite" id="passwordNew-error-empty">{{
                CONSTANTS.passwordEmptyError
              }}</span>
            }
            @if (passwordNewHasLowercase) {
              <span
                data-test-id="change-password-new-password-lowercase-error"
                class="invalid-feedback"
                aria-live="polite"
                id="passwordNew-error-lowercase"
                >{{ CONSTANTS.passwordLowercaseError }}</span
                >
              }
              @if (passwordNewHasNumber) {
                <span data-test-id="change-password-new-password-number-error" class="invalid-feedback" aria-live="polite" id="passwordNew-error-number">{{
                  CONSTANTS.passwordNumberError
                }}</span>
              }
              @if (passwordNewValidLength) {
                <span
                  data-test-id="change-password-new-password-length-error"
                  class="invalid-feedback"
                  aria-live="polite"
                  id="passwordNew-error-length"
                  >{{ CONSTANTS.passwordLengthError }}</span
                  >
                }
                @if (passwordNewHasUppercase) {
                  <span
                    data-test-id="change-password-new-password-uppercase-error"
                    class="invalid-feedback"
                    aria-live="polite"
                    id="passwordNew-error-uppercase"
                    >{{ CONSTANTS.passwordUppercaseError }}</span
                    >
                  }
                  @if (isPasswordNewGreaterThanMax) {
                    <span
                      data-test-id="change-password-new-password-max-error"
                      class="invalid-feedback"
                      aria-live="polite"
                      id="passwordNew-error-max"
                      >{{ CONSTANTS.passwordGreaterThanMax }}</span
                      >
                    }
                    @if (isPasswordNewDifferentThanUsername) {
                      <span
                        data-test-id="change-password-new-password-username-error"
                        class="invalid-feedback"
                        aria-live="polite"
                        id="passwordNew-error-username"
                        >{{ CONSTANTS.passwordContainsUsername }}</span
                        >
                      }
                    </div>

                    <div class="indicator-wrapper indicator-large ms-3">
                      <app-complexity-indicator data-test-id="change-password-new-password-complexity-indicator" id="passwordNew-desc" [value]="controlPasswordNew.value" [rules]="passwordRules"></app-complexity-indicator>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label data-test-id="change-password-confirm-password-label" for="password-confirmation" id="password-confirmation-label">{{ CONSTANTS.reenterPassword }}</label>
                  <div class="control-wrapper open-input-field">
                    <input
                      data-test-id="change-password-confirm-password-input"
                      type="password"
                      class="form-control col-sm-12 col-md-6 col-lg-6 col-xl-4"
                      (paste)="$event.preventDefault()"
                      id="password-confirmation"
                      formControlName="passwordConfirmation"
                      [class.is-invalid]="isPasswordConfirmationInvalid"
                      aria-required="true"
                      aria-labelledby="password-confirmation-label password-confirmation-error"
                      />
                    @if (isPasswordConfirmEmpty) {
                      <span
                        data-test-id="change-password-confirm-password-empty-error"
                        class="invalid-feedback"
                        aria-live="polite"
                        id="password-confirmation-empty"
                        >{{ CONSTANTS.passwordConfirmEmpty }}</span
                        >
                      }
                      @if (isPasswordConfirmNotMatch) {
                        <span
                          data-test-id="change-password-confirm-password-mismatch-error"
                          class="invalid-feedback"
                          aria-live="polite"
                          id="password-confirmation-not-match"
                          >{{ CONSTANTS.passwordConfirmNotMatch }}</span
                          >
                        }
                      </div>

                      <div class="indicator-wrapper indicator-small mt-3">
                        <app-complexity-indicator data-test-id="change-password-confirm-password-complexity-indicator" id="passwordNew-small" [value]="controlPasswordNew.value" [rules]="passwordRules"></app-complexity-indicator>
                      </div>
                    </div>

                    <div class="form-group group-offset">
                      <div class="control-wrapper">
                        <button
                          data-test-id="change-password-form-submit-button"
                          data-track-elem="button"
                          [attr.data-track-name]="CONSTANTS.submit"
                          type="submit"
                          class="btn btn-primary"
                          id="step3-next"
                          >
                          {{ CONSTANTS.submit }}
                        </button>
                      </div>
                    </div>
                  </form>

                  <app-save-changes-modal
                    data-test-id="change-password-save-changes-modal"
                    (cancelEditing)="cancelEditing()"
                    (continueEditing)="continueEditing()"
                    [modalId]="modalId"
                    data-track-region="Change Password"
                    >
                  </app-save-changes-modal>
